import * as React from 'react';
import { Component } from 'react';
import { IDropDownItem } from '../models/IDropDownItem';


interface IProps {
    Items: IDropDownItem[],
    OnItemSelected: (selectedItem: IDropDownItem) => void,
    OnDataRefreshRequired?: (searchValue: string) => void,
    OnValueChange?: (evt: any) => void
    Placeholder?: string,
    NoFilter?: boolean,
    SelectedItem?: IDropDownItem | null,
    DropDownLabel?: string,
    CollapseOnDropDownLabelClick?: boolean
}

interface IState {
    SelectedValue: string,
    SelectedId?: any,
    DropDownOpen: boolean,
    HighLightedIndex: number
}

export class SimpleSelectComponent extends Component<IProps, IState> {

    private dataRefreshTimeout: any;
    private SelectContainerNode: Node | null;
    private InputNode: Node | null;

    constructor(props) {
        super(props);

        this.state = {
            DropDownOpen: false,
            HighLightedIndex: 0,
            SelectedId: (this.props.SelectedItem ? this.props.SelectedItem.Id : undefined),
            SelectedValue: (this.props.SelectedItem ? this.props.SelectedItem.Value : '')
        }

        this.OnValueChange = this.OnValueChange.bind(this);
        this.HandleClickOutside = this.HandleClickOutside.bind(this);
        this.OnKeyPress = this.OnKeyPress.bind(this);
        this.OnClick = this.OnClick.bind(this);
        this.OnDropDownLabelClick = this.OnDropDownLabelClick.bind(this);
    }

    public componentWillMount() {
        document.addEventListener('click', this.HandleClickOutside, false);
    }

    public componentWillUnmount() {
        document.removeEventListener('click', this.HandleClickOutside, false);
    }

    public componentWillReceiveProps(nextProps: IProps) {
        if (nextProps.SelectedItem !== undefined) {
            if (nextProps.SelectedItem === null) {
                this.setState({
                    SelectedId: undefined,
                    SelectedValue: ''
                });
            } else {
                this.setState({
                    SelectedId: nextProps.SelectedItem.Id,
                    SelectedValue: nextProps.SelectedItem.Value
                });
            }
        }
    }

    public render() {
        let autocompleteString = (new Date()).getTime().toString();
        return (
            <div className="simple-select select-container"
                ref={node => this.SelectContainerNode = node}
                tabIndex={-1}
                onClick={this.OnClick}>
                <input type="text"
                    ref={node => this.InputNode = node}
                    autoComplete={'off__' + autocompleteString}
                    className="form-control"
                    placeholder={this.props.Placeholder ? this.props.Placeholder : ''}
                    value={this.state.SelectedValue}
                    onChange={this.OnValueChange}
                    onKeyDown={this.OnKeyPress}
                    />
                {this.RenderDropDown()}
            </div>
        );
    }

    private RenderDropDown() {
        //this.SelectContainerNode.clientWidth
        if (this.state.DropDownOpen) {
            return (
                <div className="drop-down-container"
                    style={{ width: (this.SelectContainerNode as HTMLElement).clientWidth + 'px' }}>
                    <ul className="scrollable high">
                        {this.RenderDropDownItems()}
                    </ul>
                </div>
            );
        } else {
            return null;
        }
    }

    private RenderDropDownItems() {
        if (this.props.Items === undefined) {
            return (
                <li onClick={this.OnDropDownLabelClick}>{this.props.DropDownLabel ? this.props.DropDownLabel : 'Wyszukaj'}</li>
            );
        } else {
            if (this.props.Items.length > 0) {
                if (this.props.OnDataRefreshRequired === undefined) {
                    if (this.props.NoFilter === true) {
                        return (
                            this.props.Items.map((item) => (
                                <li
                                    key={item.Id}
                                    onClick={this.OnItemSelected.bind(this, item)}
                                    className={this.props.Items.indexOf(item) === this.state.HighLightedIndex ? 'highlighted' : ''}>
                                    {item.Value}
                                </li>
                            ))
                        );
                    } else {
                        return (
                            this.props.Items
                                .filter((item) => (item.Value.toLowerCase().includes(this.state.SelectedValue.toLowerCase())))
                                .map((item) => (
                                    <li key={item.Id}
                                        onClick={this.OnItemSelected.bind(this, item)}
                                        className={this.props.Items.indexOf(item) === this.state.HighLightedIndex ? 'highlighted' : ''}>
                                        {item.Value}
                                    </li>
                                ))
                        );
                    }
                } else {
                    return (
                        this.props.Items.map((item) => (
                            <li
                                key={item.Id}
                                onClick={this.OnItemSelected.bind(this, item)}
                                className={this.props.Items.indexOf(item) === this.state.HighLightedIndex ? 'highlighted' : ''}>
                                {item.Value}
                            </li>
                        ))
                    );
                }
            } else {
                return (
                    <li onClick={this.OnDropDownLabelClick}>{this.props.DropDownLabel ? this.props.DropDownLabel : 'Wyszukaj'}</li>
                );
            }
        }
    }

    private OnValueChange(e) {
        this.setState({
            SelectedValue: e.target.value
        });
        if (this.dataRefreshTimeout) {
            clearTimeout(this.dataRefreshTimeout);
            this.dataRefreshTimeout = undefined;
        }
        this.dataRefreshTimeout = setTimeout((t) => {
            if (t.props.OnDataRefreshRequired !== undefined) {
                t.props.OnDataRefreshRequired(t.state.SelectedValue);
            }
            clearTimeout(t.dataRefreshTimeout);
        }, 350, this);
        if (this.props.OnValueChange) {
            this.props.OnValueChange(e);
        }
    }

    private HandleClickOutside(e: MouseEvent) {
        if (this.SelectContainerNode !== null && this.InputNode !== null) {
            if (this.SelectContainerNode.contains(e.target as HTMLElement)) {
                if (this.InputNode.isEqualNode(e.target as Node)) {
                    this.setState({
                        DropDownOpen: true
                    });
                } else {
                    this.setState({
                        DropDownOpen: true
                    });
                }
            } else {
                this.setState({
                    DropDownOpen: false
                });
            }
        }
    }

    private OnItemSelected(item: IDropDownItem, e) {
        this.setState({
            SelectedValue: item.Value,
            DropDownOpen: false
        });
        this.props.OnItemSelected(item);
    }

    private OnKeyPress(evt) {
        switch (evt.key) {
            case 'ArrowDown':
                this.setState({
                    HighLightedIndex:
                        this.props.Items.length > 0 ?
                            (this.state.HighLightedIndex + this.props.Items.length + 1) % this.props.Items.length :
                            0
                });
                break;
            case 'ArrowUp':
                this.setState({
                    HighLightedIndex: this.props.Items.length > 0 ?
                        (this.state.HighLightedIndex + this.props.Items.length - 1) % this.props.Items.length :
                        0
                });
                break;
            case 'Escape':
                this.setState({
                    DropDownOpen: false
                });
                break;
            case 'Enter':
                this.OnItemSelected(this.props.Items[this.state.HighLightedIndex], evt);
                break;
        }
    }

    private OnClick(evt) {
        evt.stopPropagation();
    }

    private OnDropDownLabelClick(evt) {
        if (this.props.CollapseOnDropDownLabelClick === true) {
            this.setState({
                DropDownOpen: false
            });
        }
    }
}


// WEBPACK FOOTER //
// ./src/controls/SimpleSelect.tsx